exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".valueOnly__wrapper___3xL0Y {\n  font-size: 16px;\n  color: #000000; }\n  .valueOnly__wrapper___3xL0Y .valueOnly__groupName___1BOcY {\n    line-height: 2.19;\n    font-weight: 600;\n    font-size: 15px; }\n    @media (max-width: 576px) {\n      .valueOnly__wrapper___3xL0Y .valueOnly__groupName___1BOcY {\n        margin-top: 15px; } }\n  .valueOnly__wrapper___3xL0Y .valueOnly__text___1Z_Mg {\n    line-height: 1.81;\n    font-weight: 400;\n    font-size: 15px;\n    color: #3f3f3f;\n    display: flex; }\n    .valueOnly__wrapper___3xL0Y .valueOnly__text___1Z_Mg > img {\n      width: 14px;\n      height: 14px;\n      margin-top: 7px;\n      margin-right: 13px; }\n", ""]);

// exports
exports.locals = {
	"wrapper": "valueOnly__wrapper___3xL0Y",
	"groupName": "valueOnly__groupName___1BOcY",
	"text": "valueOnly__text___1Z_Mg"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/ValueOnly/valueOnly.scss
// module id = 4398
// module chunks = 6